import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-79" data-mp="3f2n9g4plp4u6">
      {eyebrow && <p className={`mb-3 text-sm font-bold uppercase tracking-[0.14em] ${dark ? "text-gold" : "text-gold-dark"}`} data-id="element-80" data-mp="3k1865u5n96dv">{eyebrow}</p>}
      <h2 className={`font-serif text-[1.9rem] font-extrabold leading-[1.12] sm:text-5xl ${dark ? "text-white" : "text-navy"}`} data-id="element-81" data-mp="bmgecml94fx0">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg leading-relaxed ${dark ? "text-white/80" : "text-navy/75"}`} data-id="element-82" data-mp="1u0wdp9yfrc4">{subtitle}</p>}
    </div>;
}